<template>
  <v-form
    ref="form"
    lazy-validation
    @submit.prevent="onSubmit"
    class="app-form mt-4"
  >
    <v-row>
      <v-col xs12 sm12 md6 lg6>
        <v-text-field
          label="Nome *"
          placeholder="Digite o nome da empresa"
          outlined
          dense
          color="success"
          v-model="form.name"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col md="6" sm="12" xs="12" lg="6">
        <v-text-field
          label="CNPJ *"
          placeholder="Digite o cnpj da empresa"
          outlined
          dense
          color="success"
          v-model="form.documentation"
          :rules="[rules.required]"
          v-mask="['##.###.###/####-##']"
        ></v-text-field>
      </v-col>
      <v-col md="6" sm="12" xs="12" lg="8" class="pt-0">
        <v-text-field
          label="Email *"
          placeholder="Digite o email da empresa"
          outlined
          dense
          color="success"
          v-model="form.email"
          :rules="[rules.required, rules.email]"
        ></v-text-field>
      </v-col>
      <v-col md="6" sm="12" xs="12" lg="4" class="pt-0">
        <v-text-field
          label="Telefone *"
          placeholder="Digite o telefone da empresa"
          outlined
          dense
          color="success"
          v-model="form.phone"
          :rules="[rules.required]"
          v-mask="['(##) #####-####']"
        ></v-text-field>
      </v-col>
      <v-divider class="mb-5"></v-divider>
      <v-col md="12" sm="12" xs="12" lg="12" class="pt-0">
        <v-text-field
          label="CEP *"
          placeholder="Digite o CEP*"
          outlined
          dense
          color="success"
          v-model="cep"
          :rules="[rules.required]"
          v-mask="['#####-###']"
          @keyup="handlerInputCep()"
          :loading="loader"
          :messages="msg"
        ></v-text-field>
      </v-col>
      <v-col md="6" sm="12" xs="12" lg="6" class="pt-0">
        <v-text-field
          label="Rua *"
          placeholder="Digite o nome da rua*"
          outlined
          dense
          color="success"
          v-model="form.address"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col md="2" sm="12" xs="12" lg="2" class="pt-0">
        <v-text-field
          label="Número *"
          placeholder="Digite o número*"
          outlined
          dense
          color="success"
          v-model="form.number"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col md="4" sm="12" xs="12" lg="4" class="pt-0">
        <v-text-field
          label="Complemento"
          placeholder="Digite o complemento"
          outlined
          dense
          color="success"
          v-model="form.complement"
        ></v-text-field>
      </v-col>
      <v-col md="6" sm="12" xs="12" lg="6" class="pt-0">
        <v-text-field
          label="Bairro *"
          placeholder="Digite o bairro*"
          outlined
          dense
          color="success"
          v-model="form.district"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col md="6" sm="12" xs="12" lg="6" class="pt-0">
        <v-text-field
          label="Cidade *"
          placeholder="Digite a cidade*"
          outlined
          dense
          color="success"
          v-model="form.city"
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card-actions class="ma-0">
      <v-btn
        color="warning"
        outlined
        depressed
        type="button"
        @click="$router.push({ name: `login` })"
        >Voltar para Login</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn color="success" depressed type="submit">Continuar</v-btn>
    </v-card-actions>
    <section class="loading" v-if="form.isLoading">
      <v-progress-circular indeterminate color="success"></v-progress-circular>
      <span>Enviando informações...</span>
    </section>
  </v-form>
</template>

<script>
import CepService from "@/services/cep.service";
import OrderService from "@/services/order.service";

export default {
  name: "Cadastroform",

  data: () => ({
    form: {
      name: null,
      documentation: null,
      email: null,
      phone: null,
      address: null,
      number: null,
      complement: null,
      district: null,
      city: null,
      state: null,
      zipcode: null,
    },
        
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "E-mail inválido.";
      },
    },
    
    loader: false,
    
    msg: "",

    cep: "",
  }),

  methods: {
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        OrderService
          .createCompanyRegistration(this.form)
          .subscribe({
            next: ({ data }) => {
              this.$emit("orderCreated", { order: data.solicitation, token: data.token });
              this.clearform();
            }
        });
      }
    },

    clearform() {
      this.form = {
        name: null,
        documentation: null,
        email: null,
        phone: null,
        address: null,
        number: null,
        complement: null,
        district: null,
        city: null,
        state: null,
        zipcode: null,
      };
    },
    
    handlerInputCep() {
      if (this.cep.length === 9) {
        this.loader = true;
        this.msg = "Pesquisando";
        this.searchCEP();
      }
    },

    async searchCEP() {
      try {
        const { cep, city, neighborhood, service, state, street } =
          await CepService.searchCEP(this.cep).toPromise();
        this.loader = false;
        this.msg = "Endereço encontrado";

        this.form.address = street;
        this.form.district = neighborhood;
        this.form.city = city;
        this.form.state = state;
        this.form.zipcode = cep;
      } catch (err) {
        this.loader = false;
        this.msg = "";
      }
    },    
  },
};
</script>
